import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function About() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect all users (and Google) to homepage
    navigate("/", { replace: true });
  }, [navigate]);

  return null;
}
